import {
    EXPORT_DEBIT_NOTE_FAIL,
    EXPORT_DEBIT_NOTE_SUCCESS,
    GET_DEBIT_NOTE_DETAILS_FAIL,
    GET_DEBIT_NOTE_DETAILS_SUCCESS,
    GET_DEBIT_NOTE_LISTING_FAIL,
    GET_DEBIT_NOTE_LISTING_SUCCESS,
    RESET_DEBIT_NOTE_ACTION_STATE,
    RESET_DEBIT_NOTE_STATE,
} from "./actionTypes"

const INIT_STATE = {
    debitNoteListing: [],
    debitNoteDetails: [],
    debitNoteExport: [],
    error: [],
}

const DebitNote = (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_DEBIT_NOTE_LISTING_SUCCESS:
            return {
                ...state,
                debitNoteListing: action.payload
            }
        case GET_DEBIT_NOTE_LISTING_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case GET_DEBIT_NOTE_DETAILS_SUCCESS:
            return {
                ...state,
                debitNoteDetails: action.payload
            }
        case GET_DEBIT_NOTE_DETAILS_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case EXPORT_DEBIT_NOTE_SUCCESS:
            return {
                ...state,
                debitNoteExport: action.payload
            }
        case EXPORT_DEBIT_NOTE_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case RESET_DEBIT_NOTE_ACTION_STATE:
            return {
                ...state,
                debitNoteExport: [],
                error: [],
            }
        case RESET_DEBIT_NOTE_STATE:
            return {
                ...state,
                debitNoteListing: [],
                debitNoteDetails: [],
                debitNoteExport: [],
                error: [],
            }
        default:
            return state
    }
}

export default DebitNote
